import { CHANNELS } from "../constants";

// Segmented Filled / PillWhite — the active pill is a white 6px card inside the
// track, inactive pills stay transparent with a 24px radius.
//
// w-fit, not just inline-flex: as a flex item the track would otherwise be
// stretched to the parent's full width by the default align-items: stretch.
const ChannelTabs = ({ activeType, onChange }) => {
  return (
    <div className="w-fit inline-flex items-start justify-start gap-1 p-[2px] rounded-[8px] bg-[#F8F9FE] outline outline-1 outline-[#E5E8F3] -outline-offset-1 overflow-hidden">
      {CHANNELS.map((channel) => {
        const Icon = channel.icon;
        const active = channel.type === activeType;
        return (
          <button
            key={channel.type}
            type="button"
            onClick={() => onChange(channel.type)}
            aria-pressed={active}
            className={`flex items-center justify-center gap-2 px-3 py-[6px] transition-colors ${
              active
                ? "rounded-[6px] bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] outline outline-1 outline-[#EEF0F9] -outline-offset-1"
                : "rounded-[24px]"
            }`}
          >
            <Icon size={20} className={active ? "text-[#1A2332]" : "text-[#868DA6]"} />
            <span
              className={`font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] capitalize ${
                active ? "text-[#1A2332]" : "text-[#7C829A]"
              }`}
            >
              {channel.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ChannelTabs;
